module.exports = __webpack_public_path__ + "KaTeX_Caligraphic-Regular.5592c3df.ttf";